//
// toggle Address Street Number mandatory only if Property Name is blank
//

var streetNumberToggleMandatory = (function () {
    'use strict';

    var propertyName = 'input[name*="property_name"]';
    var streetNumber = 'input[name*="street_number"]';
    var streetNumberInputs = document.querySelectorAll(streetNumber);

    function init() {
        $(streetNumberInputs).each((index, el) => {
            var propertyNameInput = $(el).closest("div[data-sf-role='separator']").find(propertyName);
            if (propertyNameInput.val() === '') {
                $(el).attr('required', 'required');
            }
        });

        $(propertyName).on("keyup", function () {
            var streetInput = $(this).closest("div[data-sf-role='separator']").find(streetNumber);
            if ($(this).val() === '') {
                streetInput.attr('required', 'required');
                streetInput.attr('aria-required', true);
                streetInput.prev('label').find('sup').html('<i class="fas fa-asterisk"></i>');
                //show error message
                if ($(streetInput).val() === '') {
                    streetInput.next().show().text('Property name or Street number field input is required');
                }
            }
            else {
                streetInput.attr('required', false);
                streetInput.attr('aria-required', false);
                streetInput.prev('label').find('sup').empty();
                //hide error message
                streetInput.next().hide();
            }
        });
    }

    if (streetNumberInputs.length) {
        init();
    }
})();
